exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blog-posts__footer{margin-bottom:40px;text-align:center;width:100%}.blog-posts__cross{background:linear-gradient(-45deg, transparent 0%, transparent 47%, #fff 47%, #fff 56%, transparent 56%, transparent 100%),linear-gradient(45deg, transparent 0%, transparent 47%, #fff 47%, #fff 56%, transparent 56%, transparent 100%);height:12px;margin-left:5px;width:12px}.blog-posts__tag{cursor:auto !important}\n", ""]);

// exports
exports.locals = {
	"blog-posts__footer": "blog-posts__footer",
	"blog-posts__cross": "blog-posts__cross",
	"blog-posts__tag": "blog-posts__tag"
};